<template>
  <!--
    DsSelect — native <select> con styling del DS (elements/select/select.css).
    Hereda el lenguaje del input + chevron SVG. El dropdown es OS-native.
    Las <option> van en el slot. v-model estándar.
  -->
  <select
    class="ds-select"
    :class="{ 'is-error': error, 'is-placeholder': isPlaceholder, 'ds-select--wide': wide }"
    :value="modelValue"
    :disabled="disabled"
    :aria-invalid="error ? 'true' : undefined"
    v-bind="$attrs"
    @change="$emit('update:modelValue', $event.target.value)"
  >
    <slot />
  </select>
</template>

<script>
export default {
  name: 'DsSelect',
  inheritAttrs: false,
  props: {
    modelValue: { type: [String, Number], default: '' },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    wide: { type: Boolean, default: true },
  },
  emits: ['update:modelValue'],
  computed: {
    isPlaceholder() {
      return this.modelValue === '' || this.modelValue == null;
    },
  },
};
</script>

<style scoped lang="scss">
.ds-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: var(--font-sans);
  font-size: var(--text-body-s-size);
  font-weight: 400;
  color: var(--text-default);
  background-color: var(--surface-elevated);
  height: 40px;
  padding: 0 var(--space-4);
  padding-right: 36px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  outline: none;
  cursor: pointer;
  box-sizing: border-box;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%235A6260' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='4,6 8,10 12,6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right var(--space-4) center;
  background-size: 16px 16px;
  transition:
    border-color var(--duration-base, 240ms) var(--ease-default, ease),
    background-color var(--duration-base, 240ms) var(--ease-default, ease),
    box-shadow var(--duration-base, 240ms) var(--ease-default, ease);
}
.ds-select--wide { width: 100%; }
@media (pointer: coarse) { .ds-select { font-size: 16px; } }
.ds-select::-ms-expand { display: none; }

.ds-select.is-placeholder { color: var(--text-muted); }
.ds-select option { color: var(--text-default); background: var(--surface-elevated); }

@media (hover: hover) and (pointer: fine) {
  .ds-select:hover:not([disabled]) { border-color: var(--text-muted); }
}
.ds-select:focus-visible {
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent);
}
.ds-select.is-error,
.ds-select[aria-invalid="true"] { border-color: var(--border-error); }
.ds-select.is-error:focus-visible,
.ds-select[aria-invalid="true"]:focus-visible {
  border-color: var(--border-error);
  box-shadow: 0 0 0 1px var(--border-error);
}
.ds-select[disabled] {
  background-color: var(--surface-disabled);
  color: var(--text-disabled);
  border-color: var(--border-disabled);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23B8B0A0' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='4,6 8,10 12,6'/%3E%3C/svg%3E");
  cursor: not-allowed;
  pointer-events: none;
}
</style>
